import { Injectable } from '@angular/core';
import { AlertService } from "../custom-component/alert/alert.service";

@Injectable({
    providedIn: "root",
})
export class SnackBarService {

    dismissed: boolean = true;

    constructor(
        private _alertService: AlertService
    ) {
    }


    getDismissed(): boolean {
        return this.dismissed;
    }

    openSnackBar(title: string, action = "success", duration = 3000) {
        /*this.zone.run(() => {
            this.snackBar.open(message, "Close", {
                horizontalPosition: 'left',
                verticalPosition: 'bottom',
                duration: duration,
            });
        });*/
        this._alertService.showWithMessage(action + "AlertBox", title, null);
        setTimeout(() => {
            this._alertService.dismiss(action + "AlertBox");
        }, duration)

    }

    openSnackBarWithMessage(title: string, subTitle: string, action = "success", duration = 2000) {
        this._alertService.showWithMessage(action + "AlertBox", title, subTitle);
        setTimeout(() => {
            this._alertService.dismiss(action + "AlertBox");
        }, duration)
    }
}
